import React from 'react';
import { Send } from 'lucide-react';
import { useLeadForm } from '../LeadFormContext';
export function FinalCta() {
  const {
    openForm
  } = useLeadForm();
  return <section className="bg-[#0A1A3F] text-white px-5 py-16 md:px-12 lg:px-24" data-id="element-54">
      <div className="max-w-2xl mx-auto text-center" data-id="element-55">
        <h2 className="font-heading font-bold text-[28px] md:text-[40px] leading-tight mb-4" data-id="element-56">
          Готовы выбрать трактор?
        </h2>
        <p className="text-base md:text-lg text-white/70 leading-relaxed mb-8" data-id="element-57">
          Оставьте заявку — подберём модель, рассчитаем лизинг и организуем
          доставку. Бесплатно.
        </p>

        <button onClick={openForm} className="flex items-center justify-center gap-2.5 w-full md:w-auto md:inline-flex bg-[#25D366] hover:bg-[#1da851] text-white font-heading font-bold text-lg min-h-[56px] px-8 rounded-2xl transition-colors cursor-pointer" data-id="element-58">
          <Send className="w-5 h-5" data-id="element-59" />
          Оставить заявку
        </button>

        {/* Company info */}
        <p className="text-xs text-white/40 mt-8 leading-relaxed" data-id="element-60">
          ООО Профпарк · Механизация с 1995 года
        </p>
      </div>
    </section>;
}